var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"SubLayout"},[_c('SubSider',{staticClass:"SubSider",attrs:{"defaultActive":_vm.defaultActive,"navData":_vm.navData},on:{"select":_vm.handleGo}}),_c('SubContent',{staticClass:"SubContent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }